export const documentDropdown = {
	HANDOVER_DOCUMENT: 1,
	DELIVERY_CHALLAN: 2,
	SUPPLIER_CANCELLED_CHEQUE: 3,
	DISPATCH_WEIGHT_SLIP: 4,
	BILL_OF_TRANSPORT: 9,
	SUPPLIER_INVOICE: 10,
	QC_LAB_REPORT: 28,
	TAX_DOCUMENTS: 29,
};
